import { OverflowTooltip } from '@/components';
import { CompanyAvatar } from '@/components/CompanyAvatar/CompanyAvatar';
import { TableColumn, TableRow } from '@/components/Table/types';
import {
  automationsCountColumnConfig,
  businessAreasCountColumnConfig,
  deleteRowColumnConfig,
  organizationNameColumnConfig,
} from '@/utils';
import { processesCountColumnConfig } from '@/utils/tableColumns/processes-count-column-config';
import { toggleStatusColumnConfig } from '@/utils/tableColumns/toggle-status-column-config';
import { Trans } from 'react-i18next';
import { CompanyModel } from '../../domain';

type CompaniesColumnsConfig = {
  onClick?: (row?: TableRow) => void;
  disableDeleteMessage?: string;
  onDeleteClick: (row?: TableRow) => void;
  onStatusChange: (checked: boolean, row: TableRow) => void;
};

export const getCompaniesColumns = ({
  onClick,
  disableDeleteMessage,
  onDeleteClick,
  onStatusChange,
}: CompaniesColumnsConfig): Array<TableColumn<CompanyModel>> => {
  return [
    {
      id: 'name',
      label: <Trans i18nKey={'name'} />,
      acessorKey: 'name',
      sortable: true,
      align: 'left',
      alignHeader: 'left',
      className: 'max-w-[20vw] w-[20vw]',
      render: (_, row) => (
        <div
          className="flex items-center gap-2.5 overflow-hidden"
          onClick={() => onClick?.(row)}
        >
          <CompanyAvatar
            companyId={row.id}
            name={row.name}
            size="small"
            hasImage={!!row.profileImageFileId}
          />
          <OverflowTooltip text={row.name} textClassName="font-black" />
        </div>
      ),
    },
    organizationNameColumnConfig(),
    toggleStatusColumnConfig({
      onChange: onStatusChange,
    }),
    {
      id: 'employees',
      acessorKey: 'usersCount',
      label: <Trans i18nKey={'employees'} />,
      sortable: true,
    },
    businessAreasCountColumnConfig(),
    processesCountColumnConfig(),
    automationsCountColumnConfig({
      options: {
        className: 'w-25',
      },
    }),
    deleteRowColumnConfig({
      disabledMessage: disableDeleteMessage,
      onDeleteClick: onDeleteClick,
    }),
  ];
};

export const getCompaniesColumnsNamedMapped = (columnName: string) => {
  const organizationsColumnsNamedMapped: Record<string, string> = {
    id: 'Id',
    name: 'Name',
    organizationName: 'OrganizationName',
    status: 'Status',
    users: 'UsersCount',
    businessAreasCount: 'BusinessAreasCount',
    'business-areas': 'BusinessAreasCount',
    processesCount: 'ProcessesCount',
    automationsCount: 'AutomationsCount',
    automations: 'AutomationsCount',
  };

  return organizationsColumnsNamedMapped[columnName] ?? 'Name';
};
